import React from 'react';
import { Outlet } from 'react-router-dom';
import SettingsHeader from '@/pages/Settings/SettingsHeader';
import ConnectSubNav from '../ConnectSubNav';

const SHARING_SUBNAV_ITEMS = [{ key: 'public-urls', label: 'Public URLs' }];

export const SharingLayout: React.FC = () => {
  return (
    <>
      <SettingsHeader headerText="Sharing" subText="Manage public URLs for kiosk displays." />
      <ConnectSubNav basePath="/connect/sharing" items={SHARING_SUBNAV_ITEMS} />
      <Outlet />
    </>
  );
};

export default SharingLayout;
